define('views/modules/setting/business/blocks/custom-tags/custom-tags',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'moment',
    // collections
    'collections/calendar/session/tags',
    // views
    'views/parts/info-section',
    'views/modules/calendar/animated-session/tags/manager/custom-tags-manager-panel',
    // templates
    'text!templates/modules/setting/business/blocks/custom-tags/custom-tags.html'

], function(
    // Libs
    _, Backbone, Mustache, U, moment,
    // collections
    CTags,
    // views
    VInfoSection,
    VCustomTagsManagerPanel,
    // templates
    TCustomTags
) {

    var VCustomTags = Backbone.Epoxy.View.extend({
        template: TCustomTags,
        events: {},

        regions: {
            count: '.count',
            datas: '.datas'
        },

        initialize: function(opt) {
            this.group = opt.group;
            this.url = opt.url;

            this.collection = new CTags(null, {
                custom: true,
                group: this.group.id
            });

            this.view = {
                info: new VInfoSection({
                    title: "Your custom tags",
                    icon: "sl-icon-settings",
                    //help: "messages:helpbox-business-custom-tags-view",
                    buttonBottom: {
                        text: "Manage my custom tags",
                        context: this,
                        callback: this.onManageCustomTags
                    },
                    content: this.template,
                }),
            };

            this.listenTo(this.collection, { "sync": this.onCollectionSync });
        },

        render: function() {
            this.assign(this.view.info, this.$el) // must be first
                .applyBindings();

            this.generateZones();

            this.collection.getFirstPage();

            return this;
        },

        _renderCount: function() {
            this.zone.$count.html(this.collection.length);
        },

        _renderData: function() {
            this.zone.$datas.html(this.collection.getStringNames());
        },

        ////////////
        // events //
        ////////////

        onManageCustomTags: function(e) {
            e.preventDefault();
            var panel = this.view.manager;
            if (!panel) {
                this.view.manager = panel = new VCustomTagsManagerPanel({
                    group: this.group
                });
            }

            this.trigger('panel:stack', panel);
        },

        onCollectionSync: function(collection, options) {
            this._renderData();
            this._renderCount();
        },

    });

    return VCustomTags;
});

